import React, { memo } from 'react';
import styled from '@emotion/styled';
import { Item as ChequeItem } from '@baemingo/table-events/dist/types';
import { useSelector } from '~Hooks';
import useOrderedChequeItems, { OrderedChequeItem } from '~Hooks/useOrderedChequeItems';
import { chequeItemToLocalItem } from '~Utils/chequeItems';
import OfferItemWrapper from '~Scenes/POS/Components/Cart/Components/OfferItemWrapper';
import CartItem from '../CartItem';

/** Dimmed and non-interactive, the rows are only a reference of what is already on the cheque */
const Wrapper = styled.div`
  opacity: 0.4;
  pointer-events: none;
  border-top: 1px solid var(--colorBlueGray1100);
`;

interface Props {
  items: ChequeItem[];
  compressedCart: boolean;
}

/**
 * Renders the items that already are on the cheque (TSR) below the cart items in Handheld,
 * in the same order as the cheque view (ChequeDetails).
 */
const ChequeItems = ({ items, compressedCart }: Props) => {
  const courseTypes = useSelector((state) => state.courseTypes);
  const ordered = useOrderedChequeItems(items);

  if (items.length === 0) {
    return null;
  }

  const renderRow = (item: OrderedChequeItem, hidePrice?: boolean) => (
    <CartItem
      key={item.id}
      item={chequeItemToLocalItem(item, courseTypes)}
      compressedCart={compressedCart}
      isSelected={false}
      toggleSelectedItem={() => {}}
      hidePrice={hidePrice}
    />
  );

  return (
    <Wrapper data-testid="cart-cheque-items">
      {ordered.unmatched.map((item) => renderRow(item))}
      {ordered.matches.map((offerMatch, index) => (
        <OfferItemWrapper
          key={`offer-${index}`}
          offerId={offerMatch.offerId}
          oldPrice={offerMatch.oldPrice}
          newPrice={offerMatch.newPrice}>
          {offerMatch.items.map((item) => renderRow(item, true))}
        </OfferItemWrapper>
      ))}
    </Wrapper>
  );
};

export default memo(ChequeItems);
